import * as React from "react";
import { haversineDistance } from "../utils/geo";

export function useMeasure() {
  const [measuring, setMeasuring] = React.useState(false);
  const [measurePoints, setMeasurePoints] = React.useState<
    google.maps.LatLngLiteral[]
  >([]);
  const [measureClosed, setMeasureClosed] = React.useState(false);
  const [measureSessionId, setMeasureSessionId] = React.useState(0);

  const measurePolylineRef = React.useRef<google.maps.Polyline | null>(null);
  const measureOverlaysRef = React.useRef<Array<google.maps.MVCObject>>([]);

  function clearMeasurement() {
    for (const ov of measureOverlaysRef.current) {
      // @ts-ignore
      ov.setMap && ov.setMap(null);
    }
    measureOverlaysRef.current = [];

    if (measurePolylineRef.current) {
      try {
        measurePolylineRef.current.setPath([]);
      } catch {}
      measurePolylineRef.current.setMap(null);
      measurePolylineRef.current = null;
    }

    setMeasurePoints([]);
    setMeasureClosed(false);
    setMeasureSessionId((n) => n + 1);
  }

  const totalDistanceKm = React.useMemo(() => {
    if (measurePoints.length < 2) return 0;

    const geom = google?.maps?.geometry?.spherical;
    if (geom?.computeLength) {
      const meters = geom.computeLength(
        measurePoints.map((p) => new google.maps.LatLng(p.lat, p.lng))
      );
      return meters / 1000;
    }

    // Fallback
    return measurePoints.reduce(
      (sum, p, i, arr) => (i ? sum + haversineDistance(arr[i - 1], p) : 0),
      0
    );
  }, [measurePoints]);

  return {
    measuring,
    setMeasuring,
    measurePoints,
    setMeasurePoints,
    measureClosed,
    setMeasureClosed,
    measureSessionId,
    measurePolylineRef,
    measureOverlaysRef,
    clearMeasurement,
    totalDistanceKm,
  };
}
export type UseMeasure = ReturnType<typeof useMeasure>;
